import i18next from 'i18next';
import { ICurrentApplicationData } from './ApplicationsBarChart';

type Statuses = {
  created: number;
  in_progress: number;
  completed: number;
  closed: number;
  expired: number;
};

type ChartDataItem = {
  all_count: number;
  statuses: Statuses;
};

type ChartDataType = [string, ChartDataItem];

export const applicationChartOptions = (data: ChartDataType[]) => {
  return {
    layout: {
      padding: { top: 40 },
    },
    plugins: {
      datalabels: {
        anchor: 'end' as const,
        align: 'top' as const,
        offset: 5,
        color: '#000',
        font: {
          weight: 'bold' as const,
          size: 14,
        },
        formatter: (value: number) => (value === 0 ? '' : value),
      },
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: '',
            size: 14,
            weight: 500,
          },
          color: '#333',
          padding: 10,
          boxWidth: 8,
          boxHeight: 8,
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context: any) => {
            const label = context.dataset.label || '';
            return `${label}`;
          },
          afterBody: (context: any) => {
            const dataIndex = context[0].dataIndex;
            const category = data[dataIndex][1];

            if (!category) return [];

            const { statuses, all_count } = category;

            return [
              '',
              `${i18next.t('total_requests')}: ${all_count}`,
              '',
              `${i18next.t('created_by')}: ${statuses.created}`,
              `${i18next.t('completed')}: ${statuses.completed}`,
              `${i18next.t('in_progress')}: ${statuses.in_progress}`,
              `${i18next.t('closed')}: ${statuses.closed}`,
              `${i18next.t('expired')}: ${statuses.expired}`,
            ];
          },
        },
        backgroundColor: '#000',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 4,
        padding: 10,
      },
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };
};

export const currentOptions = (data: ICurrentApplicationData[]) => {
  return {
    layout: {
      padding: { top: 20 },
    },
    plugins: {
      datalabels: {
        anchor: 'end' as const,
        align: 'top' as const,
        offset: 5,
        color: '#000',
        font: {
          weight: 'bold' as const,
          size: 14,
        },
        formatter: (value: number) => (value === 0 ? '' : value),
      },
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: '',
            size: 14,
            weight: 500,
          },
          color: '#333',
          padding: 10,
          boxWidth: 8,
          boxHeight: 8,
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context: any) => {
            const label = context.dataset.label || '';
            return `${label}`;
          },
          afterBody: (context: any) => {
            const dataIndex = context[0].dataIndex;
            const category = data[dataIndex];

            if (!category) return [];

            const { statistic, all_count } = category.data;

            return [
              '',
              `${i18next.t('total_orders')}: ${all_count}`,
              '',
              `${i18next.t('created_by')}: ${statistic.created}`,
              `${i18next.t('completed')}: ${statistic.completed}`,
              `${i18next.t('in_progress')}: ${statistic.in_progress}`,
              `${i18next.t('closed')}: ${statistic.closed}`,
              `${i18next.t('expired')}: ${statistic.expired}`,
            ];
          },
        },
        backgroundColor: '#000',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 4,
        padding: 10,
      },

      responsive: true,
      maintainAspectRatio: false,
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
    },
  };
};
